export default function NovoEditorJs(){
    
    function parseJSONToHTML(json) {
        
        if(!json ||  json == 'None') return
        const data = JSON.parse(json);
        console.log(data)
        
        let html = '';
        let insideGrid = false;
        let currentColumn = '';
    
        for (const block of data.blocks) {
            if (block.type === 'paragraph') {
                const text = block.data.text.trim();
    
                if (text === '[#init-grid]') {
                    html += '<div class="grid-container">';
                    insideGrid = true;
                    continue;
                }
    
                if (text === '[#end-grid]' && insideGrid) {
                    if (currentColumn) {
                        html += '</div>'; // Fechar a última coluna
                        currentColumn = '';
                    }
                    html += '</div>'; // Fechar o grid-container
                    insideGrid = false;
                    continue;
                }
    
                const colMatch = text.match(/\[#col-(\d+)\]/);
                if (colMatch && insideGrid) {
                    if (currentColumn) {
                        html += '</div>'; // Fechar a coluna anterior
                    }
                    currentColumn = `col-${colMatch[1]}`;
                    html += `<div class="${currentColumn}">`;
                    continue;
                }
            }
    
            // Adicionar conteúdo dentro da coluna atual ou do grid
            if (insideGrid && currentColumn) {
                html += handleBlock(block);
            } else if (!insideGrid) {
                // Adicionar conteúdo fora do grid normalmente
                html += handleBlock(block);
            }
        }
    
        // Fechar qualquer coluna ou grid-container que permaneça aberto
        if (insideGrid) {
            if (currentColumn) {
                html += '</div>'; // Fechar a última coluna
            }
            html += '</div>'; // Fechar o grid-container
        }
    
        return html;
    }
    
    // Função auxiliar para tratar diferentes tipos de blocos
    function handleBlock(block) {
        let blockHTML = '';
    
        switch (block.type.toLowerCase()) { // Converter o tipo para minúsculas
            case 'paragraph':
                const text = block.data.text.trim();
                if (text === '[#video-conteudo]') {
                    blockHTML = `<div>
                    <video 
                        src="${window.singleVideoPost}"
                        controls
                        width="600"
                        preload="metadata"
                    >
                        Your browser does not support the video tag.
                    </video>
                </div>`
                   
                }else{
                    blockHTML = `<p class="paragraph">${block.data.text}</p>`;
                }

                break;
            case 'header':
                blockHTML = `<h${block.data.level} class="header">${block.data.text}</h${block.data.level}>`;
                break;
            case 'table':
                // blockHTML = `<table class="table">${block.data.content}</table>`;
                blockHTML = '<div class="table-container"><table class="table">';
    
                block.data.content.forEach((row, rowIndex) => {
                    if (rowIndex === 0) {
                        // First row as header
                        blockHTML += '<thead><tr>';
                        row.forEach(cell => {
                            blockHTML += `<th>${cell}</th>`;
                        });
                        blockHTML += '</tr></thead><tbody>';
                    } else {
                        // Other rows as body
                        blockHTML += '<tr>';
                        row.forEach(cell => {
                            blockHTML += `<td>${cell}</td>`;
                        });
                        blockHTML += '</tr>';
                    }
                });
            
                blockHTML += '</tbody></table></div>';
                break;
            case 'raw':
                blockHTML = `<div class="raw">${block.data.html}</div>`;
                break;
            case 'delimiter':
                blockHTML = '<hr class="delimiter">';
                break;
            case 'code':
                blockHTML = `<pre class="code"><code>${block.data.code}</code></pre>`;
                break;
            case 'quote':
                blockHTML = `<blockquote class="quote">${block.data.text}</blockquote>`;
                break;
            case 'list':
                const listItems = block.data.items.map(item => `<li>${item}</li>`).join('');
                const listStyle = block.data.style === 'ordered' ? 'ol' : 'ul';
                blockHTML = `<${listStyle} class="list">${listItems}</${listStyle}>`;
                break;
            case 'embed':
                blockHTML = `
                <div class="wrapper-embed">
                    <div class="embed ${block.data.service}">
                        <iframe width="${block.data.width}" height="${block.data.height}" src="${block.data.embed}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </div>
                </div>`;
                break;
            case 'checklist':
                const checklistItems = block.data.items.map(item => {
                    const checked = item.checked ? 'checked' : '';
                    return `<li>
                        <input type="checkbox" onclick="return false;" ${checked}>
                        <label>${item.text}</label>
                    </li>`;
                }).join('');
                blockHTML = `<ul>${checklistItems}</ul>`;
                break;
            case 'image':
                blockHTML = `<div class="image-container-blog"><img src="${block.data.file.url || 'default.jpg'}" alt="${block.data.caption}" class="image"></div>`;
                break;
            case 'warning':
                blockHTML = `<div class="warning">
                    <h3>${block.data.title}</h3>
                    <p>${block.data.message}</p>
                </div>`;
                break;
            default:
                // Tratar tipos de blocos desconhecidos aqui
                blockHTML = `<div class="unknown-block">Tipo desconhecido: ${block.type}</div>`;
                break;
        }
    
        return blockHTML;
    }

    const blogContentEls = document.querySelectorAll('[editor-js-init]')

    blogContentEls && blogContentEls.forEach((blogContent) =>{
        if (blogContent.dataset.conteudo) {
            const htmlParsed = parseJSONToHTML(blogContent.dataset.conteudo)
            // console.log(htmlParsed);
            blogContent.innerHTML = htmlParsed

            const allLinks = blogContent.querySelectorAll('a')
            if(allLinks){
                allLinks.forEach(a => {
                    a.setAttribute('target','_blank')
                })
            }

        } else {
            console.log("talvez voce esqueceu do ? data-conteudo='' ")
            console.log('SEM CONTEUDO ;')
        }
    })
 
}